import { browserTracingIntegration, replayIntegration } from "@sentry/browser";
import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_WEBAPP_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_WEBAPP_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      browserTracingIntegration(),
      replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: (
      [
        // Match only the API backend — exclude assets.apprevbooster.com (static CDN).
        // A broad *.apprevbooster.com pattern adds sentry-trace/baggage headers to
        // static asset requests, triggering CORS preflight failures on the CDN.
        /^https?:\/\/(?:api|dev|app)\.apprevbooster\.com/,
        import.meta.env.VITE_API_URL ?? "",
      ] as (RegExp | string)[]
    ).filter(Boolean),
    environment: import.meta.env.VITE_ENVIRONMENT,
    normalizeDepth: 10,
  });
}

export const sentryCaptureException = (error: Error): void => {
  if (import.meta.env.VITE_WEBAPP_SENTRY_DSN) {
    Sentry.captureException(error);
  }
};
